<template>
<md-layout md-column class="ql-cue-list">
    <p v-if="!cues.length" class="md-body-2">You haven't created any cues on this page. Select text or right click on the document to add a cue.</p>
    <project-cues-cue v-for="cue in cues" 
        :key="cue.id" 
        :cue="cue"
        :open="isOpen(cue)"
        :layers="layers" 
        :locked="locked"
        @openCue="openCue(cue)" 
        @closeCue="closeCue(cue)"
        @destroy="destroy"
        @updatedCue="updatedCue" />
</md-layout>
</template>

<script>
/**
 * Component For...
 */
import ProjectCuesCue from '@/components/project/cues/cue';

const ProjectCueList = {
    name: 'projectCueList',
    props: ['cues', 'openCues', 'layers', 'locked'],
    data: function() {
        return {};
    },
    methods: {
        isOpen(cue) {
            const cueSet = new Set(this.openCues);
            return cueSet.has(cue.id);
        },
        openCue(cue) {
            this.$emit('openCue', cue);
        },
        closeCue(cue) {
            this.$emit('closeCue', cue);
        },
        destroy(cue) {
            this.$emit('destroy', cue);
        },
        updatedCue(cue) {
            this.$emit('updatedCue', cue);
        }
    },
    components: {
        'project-cues-cue': ProjectCuesCue
    }
};

export default ProjectCueList;
</script>

<style lang="scss">
.ql-cue-list {
    position: relative;
    padding-top: 6px;
    padding-left: 15px;
}
</style>


// WEBPACK FOOTER //
// cue-list.vue?26c21f6c